import type { SVGProps } from "react";
// generated from Database.svg — do not edit manually
// prettier-ignore
export default function Database(props: SVGProps<SVGSVGElement>) {
  return (<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" {...props}><path d="M 21 5 C 21 6.657 16.971 8 12 8 C 7.029 8 3 6.657 3 5 M 21 5 C 21 3.343 16.971 2 12 2 C 7.029 2 3 3.343 3 5 M 21 5 V 19 C 21 20.66 17 22 12 22 C 7 22 3 20.66 3 19 V 5 M 21 12 C 21 13.66 17 15 12 15 C 7 15 3 13.66 3 12" stroke="currentColor" strokeWidth="1.5"/></svg>);
}
